import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, MenuItem, Button
} from '@mui/material';
import { Assignment } from '../services/assignmentService';

interface EditAssignmentDialogProps {
  open: boolean;
  assignment: Assignment | null;
  onClose: () => void;
  onSave: (fields: Partial<Assignment>) => void;
}

const statusOptions = ['assigned', 'in-progress', 'completed'];

const EditAssignmentDialog: React.FC<EditAssignmentDialogProps> = ({
  open,
  assignment,
  onClose,
  onSave
}) => {
  const [status, setStatus] = useState('assigned');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // Populate fields when dialog opens or assignment changes
  useEffect(() => {
    setStatus(assignment?.status || 'assigned');
    // Convert ISO string to local datetime string for input
    setStartDate(
      assignment?.start_date
        ? new Date(assignment.start_date).toISOString().slice(0, 16)
        : ''
    );
    setEndDate(
      assignment?.end_date
        ? new Date(assignment.end_date).toISOString().slice(0, 16)
        : ''
    );
  }, [assignment, open]);

  const handleSave = () => {
    // Convert local datetime to ISO string if needed
    const isoEndDate = endDate ? new Date(endDate).toISOString() : '';
    const isoStartDate = startDate ? new Date(startDate).toISOString() : '';
    onSave({ status, start_date: isoStartDate, end_date: isoEndDate });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Edit Assignment</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          select
          label="Status"
          value={status}
          onChange={e => setStatus(e.target.value)}
          fullWidth
        >
          {statusOptions.map(opt => (
            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
          ))}
        </TextField>
        <TextField
          margin="dense"
          label="Start Date"
          type="datetime-local"
          value={startDate}
          onChange={e => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          fullWidth
        />
        <TextField
          margin="dense"
          label="Due Date"
          type="datetime-local"
          value={endDate}
          onChange={e => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditAssignmentDialog;